<div class="ai-logo-container">
  <span class="ai-text">AI</span>
</div>
